module.exports = __webpack_public_path__ + "static/img/sdql.15dab21.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/sdql.png
// module id = 6eaW
// module chunks = 0